<template>
  <section class="error-message" data-cy="error-message">
    <p>{{ message }}</p>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    message: { type: String, default: '' },
  },
};
</script>

<style lang="postcss" scoped>
.error-message {
  padding: var(--space-88) var(--space-48);

  p {
    color: var(--grey);
    font-size: var(--font-size-18);
    text-align: center;
    margin-bottom: 0;
  }
}
</style>
